import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommittesListComponent } from './committes-list/committes-list.component';
import { CommittesCreateComponent } from './committes-create/committes-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: CommittesListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: CommittesCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'committes-create/:id',
        component: CommittesCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommittesRoutingModule { }
